import { useState } from 'react';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import './Layout.css';

const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`layout ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Navbar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <main className="main-content">
        {children}
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
